import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Text, View } from 'react-native';

interface TileProps {
  children: React.ReactNode;
  title: string;
  upperRightComponent?: React.ReactNode;
}

export const SalesRepTileWithUpperRightComponent: React.FC<TileProps> = ({
  children,
  title,
  upperRightComponent,
}) => {
  const [styles] = useStyles();
  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Text style={styles.titleTextStyle}>{title}</Text>
        {upperRightComponent}
      </View>
      {children}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    backgroundColor: theme.colors.tileColor,
    borderRadius: 8,
    marginBottom: 8,
    padding: 16,
  },
  header: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  titleTextStyle: {
    color: theme.colors.primary,
    fontFamily: theme.fonts.primarySemiBold,
    fontSize: 18,
  },
}));
